module.exports = __webpack_public_path__ + "static/media/fem_4.32ed65f7.png";